import { useWrapRequest } from '../../components/hooks/use-wrap-request';
import { Api } from '../../core/api';
import {
    CheckInDto,
    FacilityVisitDto,
    WorkoutReviewDto
} from '../../core/api/FitnessActivityClient';
import { injectTSDI } from '../../core/tsdi';
import { VerificationType } from '../types';

export function useVerificationDetails(
    id: number | undefined,
    type: VerificationType | undefined
) {
    const { fitnessActivityClient, mobileClient } = injectTSDI(Api);

    return useWrapRequest(
        async (id, type) => {
            let baseData: FacilityVisitDto | WorkoutReviewDto;
            let checkIn: CheckInDto | undefined;
            let photoUrl: string | undefined;

            if (type === VerificationType.WORKOUT) {
                const { data } =
                    await fitnessActivityClient.admin.workoutSupportControllerGet(
                        id!
                    );
                baseData = data.baseData;
                photoUrl = data.validationPhotoUrl;
            } else {
                const { data } =
                    await fitnessActivityClient.admin.facilityVisitSupportControllerGet(
                        id!
                    );
                baseData = data.baseData;
                checkIn = data.checkIn;
                photoUrl = data.checkIn?.photoUrl;
            }

            const user =
                await mobileClient.supportApi.userSearchSupportControllerGetUser(
                    Number(baseData.userId)
                );

            return { baseData, checkIn, photoUrl, user: user.data, type };
        },
        { deps: [id, type] }
    );
}
